
<template>
  <!--新增系统消息-->
  <x-addEdit
    ref="addEdit"
    :initReqHandle="false"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
    :itemLayout="$store.state.long_itemLayout"
  >
    <template slot="publishTime" slot-scope="{formItem}">
      <a-form-item class="publish-time" :label="formItem.label" :required="formItem.props[1].rules[0].required" v-bind="$store.state.long_itemLayout">
        <a-row type="flex">
          <a-col>
            <a-form-item>
              <a-radio-group v-if="!$route.query.id" @change="publishChange" v-decorator="formItem.props" :disabled="formItem.radioDisabled">
                <a-radio :value="0">立即发送</a-radio>
                <a-radio :value="1">定时发送</a-radio>
              </a-radio-group>

              <span v-else class="ant-form-text">{{textData[formItem.props[0]]}}</span>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item>
              <a-date-picker v-if="!$route.query.id" v-decorator="formItem.dateProps" :disabled="formItem.pickerDisabled" showTime format="YYYY-MM-DD HH:mm:ss"/>

              <span v-else class="ant-form-text">{{textData[formItem.dateProps[0]]}}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form-item>
    </template>

    <template slot="msgContent" slot-scope="{formItem}">
      <a-form-item :label="formItem.label" required v-bind="$store.state.long_itemLayout">
        <!-- <div id="editor"></div> -->
        <wangedit ref='wangedit'></wangedit>
      </a-form-item>
    </template>
    <template slot="transfer" slot-scope="{formItem}">
      <a-form-item :label="formItem.label" required v-bind="$store.state.long_itemLayout">
        <Transfer ref="transfer"/>
      </a-form-item>

    </template>
  </x-addEdit>
</template>

<script>
import { fetchSelect, userRange } from '@/utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
import Moment from 'moment';
import wangedit from '@/components/package/wangedit.vue';
import Transfer from '../../transfer.vue';
export default {
  mixins: [fetchSelect, addEdit, userRange],
  name: 'addSystemMsg',
  components: {
    wangedit,
    Transfer
  },
  data () {
    return {
      scopeList: [],
      rangeList: [],
      haveRegionCity: { region: undefined, city: undefined },
      textData: {},
      messageType: 1, // 目前写死消息类型为1
      platformList: [],
      applicationList: [],
      editor: {},
      formKey: {
        title: '',
        imageId: '',
        isDelay: '',
        delayTime: '',
        aims: '',
        scopeType: '',
        pushAims: '',
        pushContent: '',
        cityScope: '',
        communityScope: '',
        accountScope: ''
      },
      formList: [
        {
          label: '标题',
          inputType: 'input',
          options: [],
          placeholder: '请输入标题',
          props: ['title', {
            validateTrigger: 'blur',
            rules: [
              { required: true, message: '请输入标题' },
              { min: 1, max: 50, message: '标题为1-50个字' },
              {pattern: this.REG.nonEmpty, message: this.MESSAGE.nonEmpty}
            ]
          }]
        },
        {
          label: '封面图片',
          inputType: 'upload',
          options: [],
          placeholder: '',
          fileList: [],
          uploadParam: {
            url: '/common/upload',
            iconUrl: 'imageUrl',
            iconName: 'imageUrl',

            action: this.$store.state.uploadUrl,
            headers: {},
            accept: this.$store.state.imgAccept,
            listType: 'picture',
            uploadType: 4
          },
          props: ['imageId', { rules: [] }]
        },
        {
          slot: 'msgContent',
          label: '消息内容',
          inputType: 'input',
          options: [],
          placeholder: '请输入消息内容',
          props: ['content', {
            validateTrigger: 'blur',
            rules: [{ required: true, message: '请输入内容' }]
          }]
        },
        {
          slot: 'publishTime',
          label: '发布时间',
          inputType: 'radioGroup',
          options: [],
          radioDisabled: false,
          pickerDisabled: true,
          props: ['isDelay',
            {initialValue: 0, rules: [{required: true, message: '请选择发布时间'}]}
          ],
          dateProps: ['delayTime', {
            rules: [{required: false, message: '请选择定时发布时间'}]
          }]
        },
        {
          label: '目标应用',
          inputType: 'radioGroup',
          options: [],
          placeholder: '',
          handle: this.pushTarget,
          props: ['aims', {
            rules: [{required: true, message: '请选择目标应用'}]
          }]
        },
        {
          label: '应用范围',
          inputType: 'select',
          options: [],
          placeholder: '请选择应用范围',
          handle: e => this.handleUserRange(e),
          props: ['scopeType', {
            rules: [{required: true, message: '请选择用户范围'}]
          }]
        },
        {
          isShow: false,
          label: '选择城市',
          inputType: 'treeSelect',
          options: [], // options的 value是字符
          placeholder: '请选择城市',
          treeCheckable: true,
          handle: this.rangeCityChange,
          props: ['cityScope', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          slot: 'transfer',
          isShow: false,
          label: '选择小区',
          inputType: 'text',
          options: [],
          placeholder: '',
          showSelectAll: false,
          selectChange: this.rangeCommunitySelected,
          change: this.rangeCommunityChange,
          props: ['communityScope', {
            rules: [{required: true, message: '请选择小区'}]
          }],
          titles: ['小区列表', '已选']
        },
        {
          isShow: false,
          label: '输入账号',
          inputType: 'textarea',
          extra: '多个账号以英文“,”逗号隔开',
          props: ['accountScope', {
            rules: [{required: true, message: '请输入账号'}]
          }]
        },
        {
          label: '同时推送',
          inputType: 'checkboxGroup',
          options: [],
          placeholder: '',
          handle: this.pushPlatForm,
          props: ['pushAims', { rules: [] }]
        },
        {
          label: '推送内容',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入推送内容',
          props: ['pushContent', {
            validateTrigger: 'blur',
            rules: [
              { required: false, message: '请输入推送内容' },
              { min: 0, max: 100, message: '推送内容为0-100个字' }
            ]
          }]
        }
      ],
      addParam: {
        url: '/messageList',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/messageList/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/messageList/',
        resHandle: this.detailResHandle
      }
    };
  },
  watch: {
    haveRegionCity: {
      deep: true,
      handler (val) {
        if (this.$route.query.id && val.region && val.city) {
          this.$refs.addEdit.getDetail();
        }
      }
    }
  },
  created () {
    this.getSelect();
    this.handleList();
  },
  methods: {
    getSelect () {
      let platformIndex = this.formList.findIndex(item => item.props && item.props[0] === 'pushAims');

      let paramArr = [
        {index: platformIndex, scope: 'formList', query: 'comu_application_platform'},
        {index: 4, scope: 'formList', query: 'comu_msg_aims'},
        {
          index: 5,
          scope: 'formList',
          query: 'comu_msg_scope_type',
          handle: this.handleRangeSelect
        }
      ];
      if (this.$route.query.id) {
        paramArr[0].handle = data => { this.platformList = data; };
        paramArr[1].handle = data => { this.applicationList = data; };
      }
      this.dictionarySelect(paramArr);
      this.userRangeList(6, 7,
        () => { this.haveRegionCity.region = true; },
        () => { this.haveRegionCity.city = true; }
      );
    },
    /* 处理form列表 */
    handleList () {
      if (this.$route.query.id) {
        this.formList[3].props[1].rules[0].required = false;
        this.formList.forEach((el) => {
          let prop = el.props && el.props[0];
          if (prop !== 'title' && prop !== 'imageId') {
            el.inputType = 'text';
          }
        });
      }
    },
    /* 处理同时推送 */
    pushPlatForm (val) {
      this.formList.forEach((el) => {
        let props = el.props;
        if (props && props[0] === 'pushContent') {
          let rules = props[1].rules[0];
          val.length ? rules.required = true : rules.required = false;

          let form = this.$refs.addEdit.form;
          let pushContent = form.getFieldValue('pushContent');
          if (pushContent) {
            if (val.length) {
              form.setFields([{pushContent: { value: pushContent }}]);
            } else {
              form.setFields([{pushContent: { value: pushContent, errors: '请输入推送内容' }}]);
            }
          } else {
            form.resetFields('pushContent');
          }
        }
      });
    },
    /* 处理用户范围 */
    handleUserRange (val, formValues) {
      val !== 2 && (this.$refs.addEdit.targetKeys = []);
      let scopeType = {
        0: { cityScope: false, communityScope: false, accountScope: false },
        1: { cityScope: true, communityScope: false, accountScope: false },
        2: { cityScope: false, communityScope: true, accountScope: false },
        3: { cityScope: false, communityScope: false, accountScope: true }
      };
      this.formList.forEach(el => {
        let props = el.props && el.props[0];
        let scopeObj = scopeType[val];
        for (let item in scopeObj) {
          if (props === item) {
            el.isShow = scopeObj[item];
          }
        }
      });
      if (formValues) {
        this.$refs.addEdit.textData = formValues;
        this.textData = formValues;
        this.$refs.addEdit.form.setFieldsValue(formValues);
      }
    },
    /* 发布时间 change */
    publishChange (e) {
      this.handleDealyTime(e.target.value);
    },
    arrTransformStr (arr) {
      return Array.isArray(arr) ? arr.join() : arr;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    reqHandle (param) {
      let arealist = this.$refs.transfer && this.$refs.transfer.targetKeys;
      param.messageType = this.messageType;
      param.delayTime && (param.delayTime = param.delayTime.format('YYYY-MM-DD HH:mm:ss'));
      if (new Date(param.delayTime).getTime() < new Date().getTime()) {
        this.$message.error('发布时间不能小于当前时间');
        return;
      }
      this.editorVal = this.$refs.wangedit.html;
      if (this.editorVal && this.editorVal != '<p><br></p>') {
        param = {...param, ...{content: this.editorVal}};
      } else {
        this.$message.error('请输入消息内容');
        return;
      }

      if (param.scopeType == 2 && arealist.length == 0) {
        this.$message.error('请选择小区');
        return;
      }
      if (param.scopeType == 2 && arealist.length != 0) {
        param.communityScope = arealist.join();
      }
      let scopeArr = ['cityScope', 'communityScope', 'accountScope'];
      scopeArr.forEach(el => {
        for (let item in param) {
          if (el === item) {
            param.scope = this.arrTransformStr(param[item]);
            delete param[el];
          }
        }
      });
      param.pushAims = this.arrTransformStr(param.pushAims);
      return param;
    },
    detailResHandle (res) {
      if (res.scopeType == 2) {
        setTimeout(() => {
          this.$refs.transfer.setTarget(res.scope.split(','));
          this.$refs.transfer.disabled = true;
        }, 0);
      }

      let values = {};
      for (let item in res) {
        if (this.formKey.hasOwnProperty(item)) {
          values[item] = res[item];
        }
      }
      values.delayTime = Moment(res.delayTimeDesc, 'YYYY-MM-DD HH:mm:ss');
      let list = this.formList[3];
      res.isDelay === 1 ? list.disabled = false : list.disabled = true;
      res.scope && (values = this.rangeResVal(values, res));
      if (res.content && res.content !== '<p><br></p>') {
        // this.editor.txt.html(res.content); // 设置editor内容
        // this.editorVal = res.content;
        this.$refs.wangedit.html = res.content;
        // this.editor.change();
      }
      let delayObj = { 0: '立即发送', 1: '定时发送' };
      values.isDelay = delayObj[res.isDelay];
      values.scopeType = res.scopeTypeDesc;
      values.delayTime = res.delayTime;

      values.pushAims = this.handleFormVal(this.platformList, values.pushAims); // platformList // 手机平台：安卓、苹果
      values.aims = this.handleFormVal(this.applicationList, values.aims); // applicationList // 应用平台：社区、管家
      values.cityScope && (values.cityScope = this.handleFormVal(this.formList[6].options, values.cityScope)); // 城市列表
      values.communityScope && (values.communityScope = this.handleFormVal(this.formList[7].options, values.communityScope)); // 小区列表

      this.handleUserRange(res.scopeType, values);
    },
    /** 处理返回字符为展现字符 */
    handleFormVal (list, value) {
      value = Array.isArray(value) ? value : [value];
      let labelArr = [];
      value.forEach((part) => {
        list.forEach((el) => {
          if ((el.value || el.key) === part) { // el.key和el.title为了兼容transfer小区列表
            labelArr.push(el.label || el.title);
          }
          if (el.children && el.children.length) {
            el.children.forEach((item) => {
              if (item.value === part) {
                labelArr.push(item.label);
              }
            });
          }
        });
      });

      return labelArr.join(', ');
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
